export const FETCH_JOB_CANDIDATES = "FETCH_JOB_CANDIDATES";
export const FETCH_JOB_CANDIDATES_SUCCESS = "FETCH_JOB_CANDIDATES_SUCCESS";
export const FETCH_JOB_CANDIDATES_FAILURE = "FETCH_JOB_CANDIDATES_FAILURE";

export const FETCH_JOB_CANDIDATE_REQUEST = "FETCH_JOB_CANDIDATE_REQUEST";
export const FETCH_JOB_CANDIDATE_SUCCESS = "FETCH_JOB_CANDIDATE_SUCCESS";
export const FETCH_JOB_CANDIDATE_FAILURE = "FETCH_JOB_CANDIDATE_FAILURE";
